import { useCallback, useEffect, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { BookType, HomeViewProps, ProductType } from "src/types";
import HomeView from "../Views/HomeView";
import { AVAILABLE_BOOKS, AVAILABLE_PRODUCTS } from "src/constants";
import { ModalView } from "../ModalView";
import { ProductDetail } from "../ProductDetail";
import { LibraryDetail } from "../LibraryDetail";

interface HomeNavigationViewProps
  extends Omit<HomeViewProps, "isModalOpen" | "handleCloseModal" | "product"> {}

export const HomeNavigationView = ({
  user,
  logout,
  benefitsData,
  supportData,
  openChat,
  isLoading,
}: HomeNavigationViewProps) => {
  const navigate = useNavigate();
  const { product, book } = useParams();
  const isModalOpen = useMemo(() => {
    return (
      (!!product && AVAILABLE_PRODUCTS.includes(product)) ||
      (!!book && AVAILABLE_BOOKS.includes(book))
    );
  }, [product, book]);

  const smoothNavigationToHome = useCallback(() => {
    navigate("/", { replace: true });
  }, [navigate]);

  const handleCloseModal = () => {
    smoothNavigationToHome();
  };

  useEffect(() => {
    if (
      (!!product && !AVAILABLE_PRODUCTS.includes(product)) ||
      (!!book && !AVAILABLE_BOOKS.includes(book))
    ) {
      smoothNavigationToHome();
    }
  }, [product, book, smoothNavigationToHome]);

  return (
    <>
      <ModalView isOpen={isModalOpen} onCloseModal={handleCloseModal}>
        {!!product && (
          <ProductDetail openChat={openChat} product={product as ProductType} />
        )}
        {!!book && (
          <LibraryDetail openChat={openChat} book={book as BookType} />
        )}
      </ModalView>
      <HomeView
        benefitsData={benefitsData}
        supportData={supportData}
        openChat={openChat}
        logout={logout}
        user={user}
        navigateToHome={smoothNavigationToHome}
        isLoading={isLoading}
      />
    </>
  );
};
